'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PersonModel = function () {
  function PersonModel(data) {
    _classCallCheck(this, PersonModel);

    this.relationships = [];
    this.logentries = [];

    this.values = {
      id: null,
      image: null,
      lastname: null,
      suffix: null,
      maidenname: null,
      maidensuffix: null,
      initials: null,
      forenames: null,
      nickname: null,
      gender: null,
      address: null,
      zipcode: null,
      city: null,
      country: null,
      phone: null,
      mobile: null,
      email: null,
      dateofbirth: null,
      dateofdeath: null,
      sendbirthdaycard: null,
      sendbirthdayemail: null,
      countryoforigin: null,
      linkedinid: null,
      twitterid: null,
      facebookid: null,
      skypeid: null,
      religion: null,
      maritalstatus: null,
      sendchristmasemail: null,
      sendchristmascard: null,
      region: null,
      nationality: null
    };

    window.PRIM.modelMapper.mapToModel(data, this.values);
  }

  _createClass(PersonModel, [{
    key: 'getTitle',
    value: function getTitle() {
      var title = [];

      if (this.values.nickname) {
        title.push(this.values.nickname);
      }

      if (this.values.suffix) {
        title.push(this.values.suffix);
      }

      if (this.values.lastname) {
        title.push(this.values.lastname);
      }

      return title.join(' ');
    }
  }, {
    key: 'getSubtitle',
    value: function getSubtitle() {
      return [this.values.city].join(' ');
    }
  }, {
    key: 'getImage',
    value: function getImage() {
      return this.values.image;
    }
  }, {
    key: 'getIndex',
    value: function getIndex() {
      if (this.getCompareString()) {
        return this.getCompareString().substring(0, 1).toUpperCase();
      }

      return null;
    }
  }, {
    key: 'getCompareString',
    value: function getCompareString() {
      var title = [];

      if (this.values.lastname) {
        title.push(this.values.lastname);
      }

      if (this.values.suffix) {
        title.push(this.values.suffix);
      }

      if (this.values.nickname) {
        title.push(this.values.nickname);
      }

      if (this.values.city) {
        title.push(this.values.city);
      }

      return title.join(' ');
    }
  }, {
    key: 'getJSON',
    value: function getJSON() {
      var result = {};

      window.PRIM.modelMapper.mapToObject(this.values, result);

      return result;
    }
  }]);

  return PersonModel;
}();

exports.default = PersonModel;


//////////////////
// WEBPACK FOOTER
// ./js/modules/person/model/PersonModel.js
// module id = 7
// module chunks = 0